import * as service from '../../services'

export const generalItems = async properties => {
  const { alive, code, commit, dateLog, recorded, treeVerified, site, specie } =
    properties || {}
  const { name: siteName, parish, section, type: typeSite, siteAcronym } = site || {}
  const { family, pseudonym } = specie || {}
  const dateFormated = new Date(dateLog)
  // ORDENAR ALFABETICAMENTE LAS OPCIONES
  const familyAll = await service.getFamilyAll()
  const specieAll = await service.getSpecieAll()
  const parishAll = await service.getParishAll()
  const siteNameAll = await service.getSiteNameAll()
  const pseudonymAll = await service.getPseudonymAll()
  const siteSectionAll = await service.getSiteSectionAll()
  const siteSiteAcronymAll = await service.getSiteAcronymAll()

  return [
    {
      x: 12,
      s: 5,
      m: 3,
      name: 'code_',
      initvalue: code,
      label: 'Código',
      disabled: true,
    },
    {
      x: 12,
      s: 7,
      m: 4,
      name: 'family_',
      initvalue: family?.id ?? '#',
      label: 'Familia',
      options: { '#': 'Escoger Familia', ...familyAll },
    },
    {
      x: 12,
      s: 12,
      m: 5,
      name: 'specie_',
      initvalue: specie?.id ?? '#',
      label: 'Especie',
      options: { '#': 'Escoger Especie', ...specieAll },
    },
    {
      x: 12,
      s: 12,
      m: 12,
      name: `pseudonym_`,
      data: pseudonym ?? [],
      options: pseudonymAll,
      label: 'Nombre común',
      variant: 'standard',
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'parish_',
      initvalue: parish?.id ?? '#',
      label: 'Parroquia',
      options: { '#': 'No definido', ...parishAll },
    },
    {
      x: 12,
      s: 6,
      m: 6,
      name: 'typeSite_',
      initvalue: typeSite ?? '#',
      label: 'Tipo de sitio',
      options: {
        '#': 'No definido',
        Avenida: 'Avenida',
        Parque: 'Parque',
        'Campus UNL': 'Campus UNL',
      },
    },
    {
      x: 12,
      s: siteName?.length > 30 ? 12 : siteName?.length > 20 ? 9 : 7,
      m:
        siteName?.length > 40
          ? 12
          : siteName?.length > 30
          ? 8
          : siteName?.length > 15
          ? 7
          : 7,
      name: 'site_',
      initvalue: siteName ?? '',
      label: 'Sitio',
      multiline: true,
      align: 'center',
      options: siteNameAll,
    },
    {
      x: 12,
      s: 5,
      m: 5,
      name: 'siteAcronym_',
      initvalue: siteAcronym,
      label: 'Acrónimo de Ubicación',
      multiline: true,
      align: 'center',
      options: siteSiteAcronymAll,
    },
    {
      x: 12,
      s: section?.length > 30 ? 12 : section?.length > 20 ? 9 : 7,
      m: section?.length > 40 ? 12 : 9,
      name: 'section_',
      initvalue: section ?? '',
      label: 'Sección',
      multiline: true,
      align: 'center',
      options: siteSectionAll,
    },
    {
      x: 12,
      s: 4,
      m: 3,
      name: 'alive_',
      initvalue: alive ? '1' : '0',
      label: 'Estado actual',
      options: { 0: 'Muerto', 1: 'Vivo' },
    },
    {
      x: 12,
      s: 6,
      m: 4,
      name: 'treeVerified_',
      initvalue: treeVerified === 'Y' ? '1' : '0',
      label: 'Estado de registro',
      options: { 0: 'No verificado', 1: 'Verificado' },
    },
    {
      x: 12,
      s: recorded?.length > 15 ? 12 : recorded?.length > 5 ? 6 : 4,
      m: recorded?.length > 40 ? 12 : recorded?.length > 30 ? 8 : 6,
      name: 'recorded_',
      initvalue: recorded ?? '',
      label: 'Nombre del colector',
      multiline: true,
      align: 'center',
    },
    {
      x: 12,
      s: commit?.length > 15 ? 12 : commit?.length > 5 ? 6 : 4,
      m: commit?.length > 37 ? 12 : commit?.length > 25 ? 8 : 8,
      name: 'commit_',
      initvalue: commit ?? '',
      label: 'Comentario',
      multiline: true,
      align: 'start',
    },
    {
      x: 12,
      s: 6,
      m: 4,
      name: 'date_',
      initvalue: dateFormated ?? new Date(),
      label: 'Fecha de registro',
      date: true,
    },
  ]
}
